var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import Sheet from 'sheet-happens';
import { AuditLogType } from '@common/api';
import FSButton from '@components/FSButton';
import SelectInput from '@shared/input/SelectInput';
import { auditLogsApi } from '@data/rest/api';
function getAuditLogs(fromDate, pageIndex, searchType) {
    return __awaiter(this, void 0, Promise, function () {
        var page, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = {
                        type: searchType,
                        pageSize: 200,
                        pageIndex: pageIndex,
                        after: fromDate,
                    };
                    return [4 /*yield*/, auditLogsApi.search(page)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    });
}
var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var allTypes = 'All';
function AuditLogRepresentationPageTitleBar(props) {
    var auditLogs = props.auditLogs, currentPage = props.currentPage, setPageIndex = props.setPageIndex;
    if (!auditLogs) {
        return null;
    }
    var handlePageClick = function (direction) {
        var newPageIndex = currentPage - 1;
        var updateRequired = false;
        if (direction === 'up') {
            if (currentPage < auditLogs.totalPageCount) {
                newPageIndex++;
                updateRequired = true;
            }
        }
        else if (direction === 'down') {
            if (currentPage > 1) {
                newPageIndex--;
                updateRequired = true;
            }
        }
        if (updateRequired) {
            setPageIndex(newPageIndex);
        }
    };
    return (React.createElement("div", null,
        React.createElement("hr", null),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-3" },
                React.createElement("b", null,
                    "Total results: ",
                    auditLogs.totalElementCount)),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center' }, className: "col-md-6" },
                "Page ",
                currentPage,
                " of ",
                auditLogs.totalPageCount,
                React.createElement("button", { onClick: function () {
                        handlePageClick('up');
                    }, style: { marginLeft: '10px' }, className: "btn btn-sm btn-default" }, "UP"),
                React.createElement("button", { onClick: function () {
                        handlePageClick('down');
                    }, style: { marginLeft: '10px' }, className: "btn btn-sm btn-default" }, "DOWN")))));
}
export default function AuditLog() {
    var e_1, _a;
    var _this = this;
    var _b = __read(React.useState(new Date().getFullYear()), 2), yearFrom = _b[0], setYearFrom = _b[1];
    var _c = __read(React.useState(new Date().getMonth()), 2), monthFrom = _c[0], setMonthFrom = _c[1];
    var _d = __read(React.useState(AuditLogType.Login), 2), auditType = _d[0], setAuditType = _d[1];
    var _e = __read(React.useState(null), 2), auditLogs = _e[0], setAuditLogs = _e[1];
    var _f = __read(React.useState([50, 200, 130, 200, 400]), 2), cellWidth = _f[0], setCellWidth = _f[1];
    var _g = __read(React.useState(0), 2), pageIndex = _g[0], setPageIndex = _g[1];
    var years = [];
    for (var i = 2021; i <= new Date().getFullYear(); i++) {
        years.push(i);
    }
    var auditTypes = [allTypes];
    try {
        for (var _h = __values(Object.values(AuditLogType)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var t = _j.value;
            auditTypes.push(t);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_a = _h.return)) _a.call(_h);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var fetchAuditLogs = function (pgIndex) {
        if (pgIndex === void 0) { pgIndex = pageIndex; }
        return __awaiter(_this, void 0, void 0, function () {
            var logs, logs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(auditType === allTypes)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getAuditLogs(new Date(yearFrom, monthFrom - 1), pgIndex)];
                    case 1:
                        logs = _a.sent();
                        setAuditLogs(logs);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getAuditLogs(new Date(yearFrom, monthFrom - 1), pgIndex, auditType)];
                    case 3:
                        logs = _a.sent();
                        setAuditLogs(logs);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var columnHeaders = function (index) {
        if (index === 0) {
            return 'Db id';
        }
        else if (index === 1) {
            return 'Date And Time';
        }
        else if (index === 2) {
            return 'User';
        }
        else if (index === 3) {
            return 'Log Type';
        }
        else if (index === 4) {
            return 'Data';
        }
        return '';
    };
    var displayData = function (x, y) {
        var _a, _b;
        if (auditLogs) {
            if (auditLogs.content[y]) {
                if (x === 0) {
                    return auditLogs.content[y].id.toString();
                }
                else if (x === 1) {
                    var date = [
                        auditLogs.content[y].creationTime.toISOString().substring(0, 10),
                        auditLogs.content[y].creationTime.toISOString().substring(11, 19),
                    ];
                    return date.join(' ');
                }
                else if (x === 2) {
                    return (_b = (_a = auditLogs.content[y].user.email) !== null && _a !== void 0 ? _a : auditLogs.content[y].user.firstName) !== null && _b !== void 0 ? _b : '';
                }
                else if (x === 3) {
                    return auditLogs.content[y].type;
                }
                else if (x === 4) {
                    return JSON.stringify(auditLogs.content[y].data);
                }
            }
        }
        return '';
    };
    var onCellWidthChange = function (indices, newWidth) {
        var e_2, _a;
        var cw = __spreadArray([], __read(cellWidth), false);
        try {
            for (var indices_1 = __values(indices), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
                var columnIdx = indices_1_1.value;
                if (columnIdx > cw.length) {
                    for (var i = cw.length; i <= columnIdx; i++) {
                        cw.push(100);
                    }
                }
                cw[columnIdx] = newWidth;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (indices_1_1 && !indices_1_1.done && (_a = indices_1.return)) _a.call(indices_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        setCellWidth(cw);
    };
    return (React.createElement("div", { style: {
            padding: 22,
            paddingTop: 66,
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            backgroundColor: 'white',
        } },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', marginBottom: 30 } },
            React.createElement(FaSearch, { style: { fontSize: 30, color: '#3B85FF', marginRight: 15 } }),
            React.createElement("h2", { style: { display: 'inline-block', margin: 0 } }, "Audit log explorer")),
        React.createElement("div", { style: {
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                border: '1px solid #E7EAF0',
                borderRadius: 10,
                minHeight: 0,
                padding: '10px',
            } },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-3" },
                    React.createElement("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                        } },
                        React.createElement("div", { style: { marginRight: '10px' } },
                            React.createElement("b", null, "After year:")),
                        React.createElement("div", { style: { width: '200px' } },
                            React.createElement(SelectInput, { name: "selectYears", searchable: true, options: years.map(function (n) {
                                    return { label: n.toString(), value: n };
                                }), placeholder: "Select a year", value: yearFrom, onChange: function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        setYearFrom(e.target.value);
                                        return [2 /*return*/];
                                    });
                                }); } })))),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                        } },
                        React.createElement("div", { style: { marginRight: '10px' } },
                            React.createElement("b", null, "After month:")),
                        React.createElement("div", { style: { width: '200px' } },
                            React.createElement(SelectInput, { name: "selectedMonth", searchable: true, options: months.map(function (n) {
                                    return { label: n.toString(), value: n };
                                }), placeholder: "Select a month", value: monthFrom, onChange: function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        setMonthFrom(e.target.value);
                                        return [2 /*return*/];
                                    });
                                }); } })))),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                        } },
                        React.createElement("div", { style: { marginRight: '10px' } },
                            React.createElement("b", null, "Log type:")),
                        React.createElement("div", { style: { width: '200px' } },
                            React.createElement(SelectInput, { name: "selectType", searchable: true, options: auditTypes.map(function (n) {
                                    return { label: n, value: n };
                                }), placeholder: "Select audit type", value: auditType, onChange: function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        setAuditType(e.target.value);
                                        setPageIndex(0);
                                        setAuditLogs(null);
                                        return [2 /*return*/];
                                    });
                                }); } })))),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement("div", { style: { marginTop: '10px' } },
                        React.createElement(FSButton, { title: "SHOW LOGS", onClick: function () {
                                fetchAuditLogs();
                            } })))),
            React.createElement(AuditLogRepresentationPageTitleBar, { setPageIndex: function (targetPageIndex) {
                    setPageIndex(targetPageIndex);
                    fetchAuditLogs(targetPageIndex);
                }, currentPage: pageIndex + 1, auditLogs: auditLogs }),
            React.createElement("div", { style: { marginTop: '15px', height: '60vh' } },
                React.createElement(Sheet, { columnHeaders: columnHeaders, displayData: displayData, sourceData: displayData, editData: displayData, cellWidth: cellWidth, onCellWidthChange: onCellWidthChange })))));
}
